import { Phone, MessageCircle, Download, CalendarCheck } from "lucide-react";
import { SITE } from "../constants/site";
import { openEnquiry } from "../lib/modal";
import { useScrollTo } from "../lib/scroll";

export default function StickyActionBar() {
  const scrollTo = useScrollTo();
  const wa = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMsg)}`;
  const items = [
    { icon: Phone, label: "Call Now", action: () => (window.location.href = `tel:${SITE.phoneRaw}`), testid: "bar-call-button" },
    { icon: MessageCircle, label: "WhatsApp", action: () => window.open(wa, "_blank"), testid: "bar-whatsapp-button" },
    { icon: Download, label: "Brochure", action: () => openEnquiry("Request Brochure"), testid: "bar-brochure-button" },
    { icon: CalendarCheck, label: "Site Visit", action: () => scrollTo("#enquire"), testid: "bar-site-visit-button" },
  ];

  return (
    <div
      data-testid="sticky-action-bar"
      className="fixed bottom-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-t border-border grid grid-cols-4"
    >
      {items.map(({ icon: Icon, label, action, testid }) => (
        <button
          key={label}
          onClick={action}
          data-testid={testid}
          className="flex flex-col items-center gap-1.5 py-3 text-foreground/80 hover:text-primary hover:bg-primary/5 transition-colors"
        >
          <Icon size={18} className="text-primary" strokeWidth={1.5} />
          <span className="text-[9px] uppercase tracking-[0.25em]">{label}</span>
        </button>
      ))}
    </div>
  );
}
